export default "__VITE_ASSET__Co6lVq_9__"